var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6129 0.568359H1.3857C1.20709 0.568359 1.05267 0.633574 0.922206 0.763894C0.791741 0.894359 0.726562 1.04877 0.726562 1.22728C0.726562 1.40579 0.791741 1.56032 0.922206 1.69071L5.5358 6.30423C5.66641 6.4347 5.82082 6.50002 5.9993 6.50002C6.17777 6.50002 6.33233 6.4347 6.46268 6.30423L11.0763 1.69067C11.2066 1.56032 11.272 1.40579 11.272 1.22725C11.272 1.04877 11.2066 0.894359 11.0763 0.763858C10.9459 0.633429 10.7914 0.568359 10.6129 0.568359Z",
    fill: "#D3D6E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortdown);
export default __webpack_public_path__ + "static/media/sortdown.ad36dc78.svg";
export { ForwardRef as ReactComponent };